import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

import { AuthProvider }
    from "./context/AuthContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./index.css";

const root = ReactDOM.createRoot(
    document.getElementById("root")
);

root.render(
    <React.StrictMode>

        <AuthProvider>
            <App />
        </AuthProvider>

    </React.StrictMode>
);